
import React from "react";
import { Box, Grid, Typography, Paper } from "@mui/material";
import {  LocalShipping, LocalShippingOutlined } from "@mui/icons-material";
import { twMerge } from "tailwind-merge";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import { useNavigate } from "react-router-dom";
import ShipmentVendorStaffLineChart from "./ShipmentVendorStaffLineChart";

export const VendorStaffAnalyticOverview = ({ statsData, isLoading }) => {
  const navigate = useNavigate();

  const stats = [
    {
      title: "Shipments",
      icon: <LocalShippingOutlined fontSize="large" className="text-blue-500" />,
      items: [
        {
          label: "Total Shipments",
          count: statsData?.totalShipments ?? 0,
          link: "/app/staff/shipment/list"
        },
        {
          label: "Collected Shipments",
          count: statsData?.collectedShipments ?? 0,
          link: "/app/staff/shipment/list?tab=Collected"
        },
      ],
      bgColor: "bg-blue-50 dark:bg-blue-900",
    },
    {
      title: "Delivery",
      icon: <LocalShipping fontSize="large" className="text-blue-500" />,
      items: [
        {
          label: "Delivered Shipments",
          count: statsData?.deliveredShipments ?? 0,
          link: "/app/staff/shipment/list?tab=Delivered"
        },
        {
          label: "Returned Shipments",
          count: statsData?.returnedShipments ?? 0,
          link: "/app/staff/shipment/list?tab=Returned"
        },
      ],
      bgColor: "bg-blue-50 dark:bg-blue-900",
    },
  ];

  if (isLoading) return <InfoGridSkeleton />;

  return (
    <Box>
      <Grid container spacing={2}>
        {stats.map((stat) => (
          <Grid
            key={stat.title}
            item
            xs={12}
            sm={6}
            md={3}
            sx={{
              transition: "transform 0.2s ease, box-shadow 0.2s ease",
              "&:hover": { transform: "scale(1.05)" }
            }}
          >
            <Paper
              className={twMerge("overflow-hidden shadow-md transition-all duration-300 p-3", stat.bgColor)}
              sx={{ borderRadius: 4, height: '100%' }}
            >
              <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                <Typography variant="h6" fontWeight="bold" className="text-gray-900 dark:text-white">
                  {stat.title}
                </Typography>
                {stat.icon}
              </Box>
              <Box>
                {stat.items.map((item, index) => (
                  <Box
                    key={index}
                    display="flex"
                    flexDirection="column"
                    justifyContent="space-between"
                    p={0.5}
                    className="hover:bg-opacity-50 rounded-lg cursor-pointer hover:bg-gray-200 dark:hover:bg-gray-1000"
                    onClick={() => navigate(item.link)}
                  >
                    <Typography variant="subtitle1" color="textSecondary">
                      {item.label}
                    </Typography>
                    {typeof item.count === 'string' || typeof item.count === 'number' ? (
                      <Typography variant="body1" fontWeight="bold" className="text-gray-900 dark:text-white">
                        {item.count}
                      </Typography>
                    ) : (
                      <Box sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {item.count}
                      </Box>
                    )}
                  </Box>
                ))}
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>

      <Grid container spacing={2} mt={2}>
        <Grid item xs={12} md={6}>
          <ShipmentVendorStaffLineChart />
        </Grid>
      </Grid>
    </Box>
  );
};